<template>
  <div class="categories-navigation">
    <ul class="level0">
      <li v-for="item in shopListItems" :key="item.id" class="level0" :class="[`cat-${item.id}`]">
        <template v-if="item.childrenData.length">
          <div class="nav-link-text has-children" v-b-toggle="`menu-acc.${item.id}`">
            <span class="link-label">
              {{item.name}}
            </span>
          </div>
          <b-collapse :id="`menu-acc.${item.id}`" accordion="hamburger-menu">
            <ul class="level1">
              <li class="level1" v-for="child in item.childrenData" :key="child.url_path">
                <!-- sub accordion -->
                <template v-if="child.childrenData.length">
                  <div class="nav-link-text has-children" v-b-toggle="`menu-sub-acc.${child.id}`">
                    <span class="link-label">
                      {{child.name}}
                    </span>
                  </div>
                  <b-collapse :id="`menu-sub-acc.${child.id}`" accordion="hamburger-menu-sub">
                    <ul class="level2">
                      <li class="level2" v-for="subDeep in child.childrenData" :key="subDeep.url_path">
                        <a href="javascript:void(0);" class="nav-link-text" @click.prevent="categoryClick(subDeep)">
                          <span class="link-label">{{ subDeep.name }}</span>
                          <svg class="o-icon"><use xlink:href="#arrow-right-short"></use></svg>
                        </a>
                      </li>
                    </ul>
                  </b-collapse>
                </template>
                <!-- single link -->
                <a href="javascript:void(0);" v-else class="nav-link-text" @click.prevent="categoryClick(child)">
                  <span class="link-label">
                    {{child.name}}
                  </span>
                  <svg class="o-icon"><use xlink:href="#arrow-right-short"></use></svg>
                </a>
              </li>
            </ul>
          </b-collapse>
        </template>
        <a v-else href="javascript:void(0);" class="nav-link-text" @click.prevent="categoryClick(item)">
          <span class="link-label">{{item.name}}</span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import filter from 'lodash/filter'
import find from 'lodash/find'
import { localizedByNameCategories } from '@/filters/routers'

export default {
  name: 'CategoriesNavigation',
  computed: {
    shopListItems () {
      return filter(this.$store.getters['ui/menu'], { include_in_menu: true, is_active: true })
    }
  },
  methods: {
    categoryClick (category) {
      let urlPath = find(category.custom_attributes, { attribute_code: 'url_path' })
      if (urlPath && urlPath.value) {
        let catId = category.origId || category.id
        this.$store.commit('category/setCategoryId', catId)
        this.$router.push({ path: localizedByNameCategories('listing', urlPath.value, null, this.$store, this.$router), query: { id: catId } })
      }
    }
  }
}
</script>
